import React, { useEffect } from "react";
import service2 from "../../assets/img/service_2.png";
import phone_icon from "../../assets/img/phone.png";
import { ReactTyped } from "react-typed";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../App.css";
import { Link } from "react-router-dom";

const CommercialCleaning = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="service_detail_page">
      <h2 className="service_detail_title" data-aos="fade-down">
        Commercial Cleaning Auckland
      </h2>

      <img
        src={service2}
        alt="Commercial Cleaning Auckland"
        className="service_detail_image"
        data-aos="zoom-in"
      />

      <p className="service_detail_cta" data-aos="fade-up">
        Consistent. Managed. Accountable.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Commercial cleaning in Auckland for organisations that require
        reliability without constant follow up. We support offices, education
        facilities, healthcare environments and multi site operations with
        structured service plans and visible quality controls.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Each site operates under a defined service schedule, assigned team
        structure, documented checks and streamlined invoicing. Health and
        Safety procedures, task documentation and compliance standards are
        embedded into operations.
      </p>

      <p className="service_detail_desc" data-aos="fade-up">
        Environmental responsibility matters. We use eco conscious products
        wherever suitable, without compromising performance.
      </p>

      <h4 className="service_subheading" data-aos="fade-up">
        Who We Support
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Corporate offices</li>
        <li>Schools and early learning centres</li>
        <li>Medical and aged care facilities</li>
        <li>Fitness centres and specialist spaces</li>
      </ul>

      <h4 className="service_subheading" data-aos="fade-up">
        Why Luxe Sparkle
      </h4>
      <ul className="service_detail_points" data-aos="fade-up">
        <li>Service schedules clearly defined and managed</li>
        <li>Quality assurance reporting maintains standards</li>
        <li>Compliance documentation available when required</li>
        <li>Systems that reduce administration for facility managers</li>
      </ul>

      <p className="service_detail_cta" data-aos="fade-up">
        Clean environments. Fewer follow ups. Clear accountability.
      </p>

      <div className="service_btn_wrapper" data-aos="fade-up">
        <Link to="/booking" className="service_btn">
          Get a Free Quote
        </Link>
      </div>

      <div className="service_contact_section">
        <div className="about_sub2">
          <div className="about_contact">
            <p className="contact-lead">
              Looking for the cleaning service in Auckland?
              <br />
              Contact us now!
            </p>
            <div className="call_btn" data-aos="fade-down">
              <div className="call_inner">
                <div className="call_icon">
                  <img src={phone_icon} alt="Phone" />
                </div>
                <a className="call-button" href="tel:092430470">
                  09 243 0470
                </a>
              </div>
            </div>
          </div>

          <div className="about_faq">
            <ReactTyped
              strings={["Need help?", "Have questions?", "Check our FAQs!"]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
            <br />
            <Link className="faq-button" to="/FAQs">
              FAQs
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommercialCleaning;
